<template>
 <div class="product">
  <div class="product-container" v-show="!info_show">
   <Header></Header>
   <Tabs @viewDetails="viewDetails"></Tabs>
   <div class="product-box">
   </div>
  </div>
  <div class="product-info-pc">
   <Info v-if="info_show" :list="_list" :itemInfo="itemInfo" @changeItem="changeItem" @close="close"></Info>
  </div>
  <div class="product-info-mobile">
   <InfoMobile v-if="info_show" :list="_list" :itemInfo="itemInfo" @changeItem="changeItem" @close="close">
   </InfoMobile>
  </div>
 </div>
</template>

<script setup>
import { computed, onMounted, ref, watch, onUnmounted } from "vue"
import Header from "./header.vue"
import Tabs from "./tabs.vue"
import Info from "./components/info.vue"
import InfoMobile from "./components/infoMobile.vue"
import { useRoute, useRouter } from "vue-router"
import { getFilterList } from "@/api/index.js"
import emitter from '@/assets/js/eventBus.js';

const router = useRouter()
const route = useRoute()


const info_show = ref(false)

const itemInfo = ref()
const _list = ref([])


const viewDetails = (data, list) => {
 itemInfo.value = data
 _list.value = list
 info_show.value = true
}

const changeItem = (data) => {
 itemInfo.value = data
}

const close = () => {
 info_show.value = false
}

const rowId = computed(() => {
 return route.query.id
})



const openInfo = async () => {
 let params = {
  page: 1,
  pageSize: 100,
  worksheetId: "6809e67bec5e343d1ca4a411",
  filters: [
   {
    "dataType": 0,
    "field": "rowId",
    "spliceType": 0,
    "values": [
     rowId.value
    ],
    "isDynamicSource": false,
    "dynamicSource": [],
    "filterType": 2
   }
  ]
 }
 const res = await getFilterList(params)

 let _params = {
  page: 1,
  pageSize: 100,
  worksheetId: "6809e67bec5e343d1ca4a411",
 }
 const _res = await getFilterList(_params)
 if (_res.code === 200 && _res.data && _res.data.length > 0 && res.code === 200 && res.data && res.data.length > 0) {
  viewDetails(res.data[0], _res.data)
 }
}
const closeIfdoFunction = () => {
 close()

}
onMounted(() => {
 emitter.on("close-info-example", closeIfdoFunction)
 if (rowId.value) {
  openInfo()
 }
})
onUnmounted(() => {
 emitter.off("close-info-example", closeIfdoFunction)
})


</script>

<style scoped lang="less">
@media screen and (max-width: 800px) {
 .product-info-pc {
  display: none;
 }

 .product-info-mobile {
  display: block;
 }
}



@media screen and (min-width: 800px) {
 .product-info-pc {
  display: block;
 }

 .product-info-mobile {
  display: none;
 }
}

.product {
 width: 100%;
 height: 100%;

}

.product-container {
 width: 100%;
 height: 100%;
}

.product-box {
 width: 1920px;
 display: flex;
 justify-content: center;
}

.product-info-pc {
 width: 100%;
 height: 100%;
}

.product-info-mobile {
 width: 100%;
 height: 100%;
}
</style>